<div class="container hide-overflow-print" #container [class.overflow-x]="!(config && config.vertical) && data && data.length"
    [class.overflow-y]="config && config.vertical && data && data.length">
    <kendo-chart #chart [ngStyle]="getStyle()" [seriesColors]="seriesColors" (seriesClick)="onSeriesClick($event)">
        <kendo-chart-value-axis>
            <kendo-chart-value-axis-item>
                <kendo-chart-value-axis-item-labels [content]="labelContent">
                </kendo-chart-value-axis-item-labels>
            </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>
        <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [majorGridLines]="majorGridLines">
                <kendo-chart-category-axis-item-labels [visual]='visual' rotation="auto"
                    [content]="categoryLabelContent">
                </kendo-chart-category-axis-item-labels>
            </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-series>
            <kendo-chart-series-item [type]="config && config.vertical ? 'bar' : 'column'" [data]="data" field="value"
                categoryField="category">
                <kendo-chart-series-item-labels [content]="labelContent"></kendo-chart-series-item-labels>
            </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category"
                let-percentage="percentage">
                {{category}} - {{labelContent({value: value})}}
            </ng-template>
        </kendo-chart-tooltip>
    </kendo-chart>
</div>